import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e2c4850"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "q-px-md q-pt-md text-h6" }
const _hoisted_2 = { class: "row no-wrap q-mb-md" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "progress q-btn__progress absolute-full overflow-hidden"
}

import { useDialogPluginComponent } from 'quasar';
import { computed, nextTick, onUnmounted, ref } from 'vue';
import AddNoteForm from 'components/history/AddNoteForm.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangeActionDialog',
  props: {
    accountKey: { default: '' },
    forceType: { default: undefined },
    historyId: { default: undefined },
    historyIds: { default: undefined },
    message: { default: '' },
    seamless: { type: Boolean, default: true },
    serial: { default: '' },
    timeout: { default: 10000 },
    type: { default: 'neutral' }
  },
  setup(__props: any) {

const props = __props as { accountKey: string, forceType: 'account' | 'device' | 'user', historyId: number, historyIds: number[], message: string, seamless: boolean, serial: string, timeout: number, type: 'positive' | 'neutral' | 'negative' };

const { dialogRef, onDialogOK, onDialogHide } = useDialogPluginComponent();



const hideAddNoteActions = ref(true);
const willAutoClose = ref(true);

const classesByType = computed(() => {
  switch (props.type) {
    case 'positive':
      return 'bg-light-green-2 text-green-10';
    default:
      return '';
  }
});

const progressStart = ref(false);
async function startTimer() {
  await nextTick();
  progressStart.value = true;
}

const autoDismiss = ref(
  setTimeout(() => {
    onDialogHide();
  }, props.timeout)
);
function cancelAutoDismiss() {
  clearTimeout(autoDismiss.value);
  willAutoClose.value = false;
}

onUnmounted(() => {
  cancelAutoDismiss();
});

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef,
    class: "dialog",
    persistent: "",
    position: "top",
    seamless: __props.seamless,
    "transition-hide": "slide-up",
    "transition-show": "slide-down",
    onShow: startTimer
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, {
        class: _normalizeClass(["card", _unref(classesByType)]),
        style: {"max-width":"60vw"}
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_q_icon, {
                class: "q-mr-sm",
                name: "check",
                size: "md"
              }),
              (__props.message)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(__props.message), 1))
                : _createCommentVNode("", true)
            ]),
            _createVNode(AddNoteForm, {
              "account-key": __props.accountKey,
              class: _normalizeClass(["add-note-form", { 'q-mb-md': !hideAddNoteActions.value }]),
              "clear-on-cancel": "",
              dialog: false,
              flat: "",
              "force-type": __props.forceType,
              "hide-actions": hideAddNoteActions.value,
              "history-id": __props.historyId,
              "history-ids": __props.historyIds,
              label: "Leave a comment about this change",
              "label-color": "off-black",
              "save-action-text": "Save & Dismiss",
              serial: __props.serial,
              update: "",
              onEmptied: _cache[0] || (_cache[0] = ($event: any) => (hideAddNoteActions.value = true)),
              onHasValue: _cache[1] || (_cache[1] = ($event: any) => {
            cancelAutoDismiss();
            hideAddNoteActions.value = false;
          }),
              onSave: _cache[2] || (_cache[2] = ($event: any) => {hideAddNoteActions.value = true; _unref(onDialogOK)()})
            }, null, 8, ["account-key", "class", "force-type", "hide-actions", "history-id", "history-ids", "serial"])
          ]),
          (hideAddNoteActions.value)
            ? (_openBlock(), _createBlock(_component_q_card_actions, {
                key: 0,
                align: "right"
              }, {
                default: _withCtx(() => [
                  _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                    class: "q-ma-sm",
                    color: "white",
                    label: "Dismiss",
                    padding: "xs md",
                    "text-color": "off-black"
                  }, {
                    default: _withCtx(() => [
                      (willAutoClose.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["progress-indicator q-btn__progress-indicator absolute fit block z-index-1", { 'progress-indicator--in-progress': progressStart.value }]),
                              style: _normalizeStyle(`transition: transform ${__props.timeout / 1000}s linear;`)
                            }, null, 6)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })), [
                    [_directive_close_popup]
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    _: 1
  }, 8, ["seamless"]))
}
}

})